import { Spinner } from "@asez/component-library";

const RenderLoading = () => {
  return (
    <div className="flex mt-32 justify-center h-[100vh]">
      <Spinner size={32} />
    </div>
  );
};

export default RenderLoading;
